import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <main id="main">
      <section className="d-flex align-items-center"></section>
      <section id="services" className="services section-bg">
        <div className="container">
          <div className="section-title">
            <span>Services</span>
            <h2>Services</h2>
            <p>
              If you require any other services, feel free to{' '}
              <Link to="/contact">contact us</Link>
            </p>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
              <div className="icon-box">
                <div className="icon">
                  <i className="bi bi-cpu-fill"></i>
                </div>
                <h4>
                  <a>Electronic design and automation</a>
                </h4>
                <p>
                  Electronic circuit design <b>|</b> PCB design <b>|</b> PCB
                  prototyping and production <b>|</b> SMD and THT components
                  assembly <b>|</b>
                  CNC machine control <b>|</b> Industrial control systems{' '}
                  <b>|</b> Robotics <b>|</b> PLC programming
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
              <div className="icon-box">
                <div className="icon">
                  <i className="bi bi-code-square"></i>
                </div>
                <h4>
                  <a>Embedded software development</a>
                </h4>
                <p>
                  MCU families: ST, Microchip, Atmel, Freescale/NXP/Qualcomm,
                  Texas Instruments (TI), SIMCOM modules, ESP32, ESP8266{' '}
                  <b>|</b> Software IDEs: IAR Embedded Workbench, STMCubeIDE, TI
                  CodeComposer Studio, Eclipse, ESP-IDF, Arduino Studio
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
              <div className="icon-box">
                <div className="icon">
                  <i className="bi bi-gear-fill"></i>
                </div>
                <h4>
                  <a>Mechanical design</a>
                </h4>
                <p>
                  Production technology <b>|</b> Industrial product design{' '}
                  <b>|</b> Technical drawings, technical documentation,
                  technical report <b>|</b> Design for manufacturing <b>|</b>{' '}
                  Additive manufacturing <b>|</b> CNC machines <b>|</b>
                  CAD/CAM Systems <b>|</b> Machine Design <b>|</b> Sheet metal
                  design <b>|</b> Reverse engineering <b>|</b> Robotics <b>|</b>{' '}
                  Blow mold <b>|</b>
                  Injection molds
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
              <div className="icon-box">
                <div className="icon">
                  <i className="bi bi-badge-3d-fill"></i>
                </div>
                <h4>
                  <a>3D printing</a>
                </h4>
                <p>
                  FDM printing <b>|</b> SLA printing <b>|</b> Request a quote
                  <span className="invisible">
                    FDM printing <b>|</b> SLA printing <b>|</b> Request a quote
                  </span>
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
              <div className="icon-box">
                <div className="icon">
                  <i className="bi bi-gear"></i>
                </div>
                <h4>
                  <a>CNC machining</a>
                </h4>
                <p>
                  CNC Milling <b>|</b> CNC Turning <b>|</b> Grinding <b>|</b>{' '}
                  Drilling <b>|</b> Request a quote
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
              <div className="icon-box">
                <div className="icon">
                  <i className="bi bi-robot"></i>
                </div>
                <h4>
                  <a>Design and control of CNC machines</a>
                </h4>
                <p>
                  We can transform your idea and specification into real machine{' '}
                  <b>|</b> Maintenance of CNC machines <b>|</b> Spare parts
                </p>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
      </section>
    </main>
  );
};

export default Services;
